<div class="img-bg inline-flex h-full w-full flex-col items-center justify-center gap-3 pt-4">
  <div class="flex w-full flex-col items-center justify-start gap-4">
    <h2
      class="textTabsColor justify-start self-stretch text-center font-['Inter'] text-3xl font-bold"
      i18n="@@YourCreditLimit">
      Your Credit Limit
    </h2>

    @if (apiError()) {
      <div
        class="flex w-full max-w-[980px] items-center justify-center rounded-2xl border border-red-100 bg-red-50 p-4 shadow-sm">
        <p class="font-['Inter'] text-sm font-semibold text-red-600">
          {{ apiError() }}
        </p>
      </div>
    } @else {
      <div class="inline-flex items-center justify-start gap-10">
        <div
          class="inline-flex h-22 w-52 flex-col items-center justify-start gap-1 rounded-[20px] bg-lime-50 px-5 py-4 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)]">
          <div class="inline-flex items-center justify-start gap-2">
            <h3 class="textTabsColor justify-start font-['Inter'] text-base font-medium" i18n="@@TotalCredit">
              Total Credit
            </h3>
            <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                class="fill-illustration-lime"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 6.75C4.27065 6.75 3.57118 7.03973 3.05546 7.55546C2.53973 8.07118 2.25 8.77065 2.25 9.5V18.5C2.25 19.2293 2.53973 19.9288 3.05546 20.4445C3.57118 20.9603 4.27065 21.25 5 21.25H19C19.7293 21.25 20.4288 20.9603 20.9445 20.4445C21.4603 19.9288 21.75 19.2293 21.75 18.5V9.5C21.75 8.77065 21.4603 8.07118 20.9445 7.55546C20.4288 7.03973 19.7293 6.75 19 6.75H5ZM16.5 12.75C16.1685 12.75 15.8505 12.8817 15.6161 13.1161C15.3817 13.3505 15.25 13.6685 15.25 14C15.25 14.3315 15.3817 14.6495 15.6161 14.8839C15.8505 15.1183 16.1685 15.25 16.5 15.25C16.8315 15.25 17.1495 15.1183 17.3839 14.8839C17.6183 14.6495 17.75 14.3315 17.75 14C17.75 13.6685 17.6183 13.3505 17.3839 13.1161C17.1495 12.8817 16.8315 12.75 16.5 12.75Z" />
              <path
                class="fill-illustration-lime"
                d="M16.485 3.569C16.7811 3.4901 17.0913 3.48028 17.3918 3.54031C17.6923 3.60034 17.9749 3.7286 18.218 3.91521C18.461 4.10181 18.6579 4.34176 18.7935 4.61654C18.9291 4.89133 18.9998 5.19359 19 5.5H9L16.485 3.569Z" />
            </svg>
          </div>
          <div class="justify-start font-['Inter'] text-2xl font-medium text-lime-500">{{ TotalCreditInK() }}</div>
        </div>

        <div
          class="inline-flex h-22 w-52 flex-col items-center justify-start gap-1 rounded-[20px] bg-rose-100 px-5 py-4 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)]">
          <div class="inline-flex items-center justify-start gap-2">
            <h3 class="textTabsColor justify-start font-['Inter'] text-base font-medium" i18n="@@RemainingCredit">
              Remaining Credit
            </h3>
            <svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2339_1992)">
                <path
                  class="stroke-illustration-red-vivid"
                  d="M16.7852 18.5H23.6423V11.6429"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  class="stroke-illustration-red-vivid"
                  d="M23.6431 18.5L13.9574 8.81429C13.7972 8.65723 13.5818 8.56927 13.3574 8.56927C13.1331 8.56927 12.9176 8.65723 12.7574 8.81429L8.81456 12.7571C8.65434 12.9142 8.43892 13.0022 8.21456 13.0022C7.99021 13.0022 7.77479 12.9142 7.61456 12.7571L1.35742 6.5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
              <defs>
                <clipPath id="clip0_2339_1992">
                  <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="justify-start font-['Inter'] text-2xl font-medium text-red-600">
            {{ RemainingCreditInK() }}
          </div>
        </div>

        <div
          class="inline-flex h-22 w-52 flex-col items-center justify-start gap-1 rounded-[20px] bg-amber-100 px-5 py-4 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)]">
          <div class="inline-flex items-center justify-start gap-2">
            <h3 class="textTabsColor justify-start font-['Inter'] text-base font-medium" i18n="@@UsedCredit">
              Used Credit
            </h3>
            <svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2339_1984)">
                <path
                  class="stroke-illustration-olive"
                  d="M16.7852 6.5H23.6423V13.3571"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  class="stroke-illustration-olive"
                  d="M23.6431 6.5L13.9574 16.1857C13.7972 16.3428 13.5818 16.4307 13.3574 16.4307C13.1331 16.4307 12.9176 16.3428 12.7574 16.1857L8.81456 12.2429C8.65434 12.0858 8.43892 11.9978 8.21456 11.9978C7.99021 11.9978 7.77479 12.0858 7.61456 12.2429L1.35742 18.5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
              <defs>
                <clipPath id="clip0_2339_1984">
                  <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="justify-start font-['Inter'] text-2xl font-medium text-yellow-600">{{ UsedCreditInK() }}</div>
        </div>
      </div>

      <div class="inline-flex h-20 flex-wrap content-start items-start justify-center self-stretch">
        <div class="flex w-[980px] items-end justify-between">
          <div class="flex items-center justify-start gap-2">
            <span class="textTabsColor justify-start font-['Inter'] text-2xl font-medium">
              {{ UsedCreditInK() }}
            </span>
            <span class="textTabsColor justify-start font-['Inter'] text-2xl font-medium" i18n="@@heroUsed">used</span>
          </div>
          <div class="flex items-center justify-start gap-2">
            <span
              class="justify-start font-['Inter'] text-2xl font-medium text-[rgba(135,139,143,1)]"
              i18n="@@heroOutOf">
              out of
            </span>
            <span class="justify-start font-['Inter'] text-2xl font-medium text-[rgba(135,139,143,1)]">
              {{ TotalCreditInK() }}
            </span>
          </div>
        </div>
        <div class="bg-helper-two relative mt-2 h-4 w-[980px] overflow-hidden rounded-[45px]">
          <div
            class="absolute top-0 h-full rounded-[45px] transition-all duration-500 ease-in-out ltr:left-0 rtl:right-0"
            [style.background]="progressBarGradient()"
            [style.width.%]="creditPercentage()"></div>
        </div>
      </div>
    }
  </div>
</div>
